document.addEventListener('DOMContentLoaded', () => {
  let players = {};
  let currentPlaying = null;
  let ytApiLoaded = false;

  function onYouTubeIframeAPIReady() {
    ytApiLoaded = true;
  }
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  document.querySelectorAll('.video-container').forEach((container, index) => {
    const id = `video-${index}`;
    container.dataset.id = id;

    if (container.dataset.videoType === 'shopify') {
      const video = container.querySelector('.hosted-video');
      players[id] = { type: 'shopify', player: video, container };

      video.addEventListener('pause', () => {
        if (video.currentTime > 0 && !video.ended) {
          container.classList.remove('playing');
          container.querySelector('.video-overlay').style.opacity = 1;
        }
      });
      video.addEventListener('ended', () => {
        container.classList.remove('playing');
        container.querySelector('.video-overlay').style.opacity = 1;
        currentPlaying = null;
      });
    }

    container.addEventListener('click', () => handlePlayPause(container));
  });

  function handlePlayPause(container) {
    const id = container.dataset.id;
    const isPlaying = container.classList.contains('playing');

    if (currentPlaying && currentPlaying.container !== container) {
      pauseVideo(currentPlaying);
    }

    if (isPlaying) {
      if (players[id]) {
        pauseVideo(players[id]);
        currentPlaying = null;
      }
    } else {
      if (players[id]) {
        playVideo(players[id]);
        currentPlaying = players[id];
      } else if (ytApiLoaded) {
        createYouTubePlayer(container).then(playerInfo => {
          players[id] = playerInfo;
          playVideo(playerInfo);
          currentPlaying = playerInfo;
        });
      }
    }
  }

  function createYouTubePlayer(container) {
    return new Promise(resolve => {
      const playerEl = container.querySelector('[id^="player-"]');
      const player = new YT.Player(playerEl.id, {
        height: '100%',
        width: '100%',
        videoId: container.dataset.youtubeId,
        playerVars: { playsinline: 1, controls: 0, showinfo: 0, rel: 0, modestbranding: 1 },
        events: {
          onReady: event => resolve({ type: 'youtube', player: event.target, container }),
          onStateChange: event => {
            const stateContainer = event.target.getIframe().closest('.video-container');
            if (event.data === YT.PlayerState.PAUSED) {
              stateContainer.classList.remove('playing');
              stateContainer.querySelector('.video-overlay').style.opacity = 1;
            } else if (event.data === YT.PlayerState.ENDED) {
              stateContainer.classList.remove('playing');
              stateContainer.querySelector('.video-overlay').style.opacity = 1;
              if (stateContainer.querySelector('.video-poster')) {
                stateContainer.querySelector('.video-poster').style.opacity = 1;
              }
              event.target.getIframe().style.display = 'none';
              currentPlaying = null;
            }
          },
        },
      });
    });
  }

  function playVideo(playerInfo) {
    playerInfo.container.classList.add('playing');
    playerInfo.container.querySelector('.video-overlay').style.opacity = 0;
    const poster = playerInfo.container.querySelector('.video-poster');
    if (poster) poster.style.opacity = 0;

    if (playerInfo.type === 'youtube') {
      playerInfo.player.getIframe().style.display = 'block';
      playerInfo.player.playVideo();
    } else {
      playerInfo.player.play();
    }
  }

  function pauseVideo(playerInfo) {
    playerInfo.container.classList.remove('playing');
    playerInfo.container.querySelector('.video-overlay').style.opacity = 1;

    if (playerInfo.type === 'youtube') playerInfo.player.pauseVideo();
    else playerInfo.player.pause();
  }

  if (document.querySelector('[data-video-type="youtube"]')) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
});
